import { jsx as _jsx } from "react/jsx-runtime";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/ChargingStationsPage.module.less";
import { canDeleteFromDictionaries, canEditDictionaries, } from "@/utils/permissions";
import { Button, Card, Modal, Skeleton, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { DataTable } from "@/components/DataTable";
import { Filters } from "@/components/filters";
export const ChargingStationsPage = observer(() => {
    const { authStore, chargingStationsStore } = getRootStore();
    const { dataTable, loading, filtersStore } = chargingStationsStore;
    const navigate = useNavigate();
    // Определяем права доступа
    const userRole = authStore.userRole;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        dataTable.setFilters(filtersStore.values);
        dataTable.loadData();
    }, [filtersStore.values]);
    const handleViewStation = (stationId) => {
        if (stationId) {
            navigate(`/charging-stations/${stationId}`);
        }
        else {
            navigate("/charging-stations/new");
        }
    };
    const handleDeleteStation = (stationId) => {
        Modal.confirm({
            title: "Удалить зарядную станцию?",
            content: "Вы уверены, что хотите удалить эту станцию?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: () => chargingStationsStore.deleteStation(stationId),
        });
    };
    const columns = [
        {
            title: "Серийный номер",
            key: "serialNumber",
            sorter: true,
            dataIndex: "serialNumber",
            render: (_, record) => (_jsx(Button, { type: "link", onClick: () => handleViewStation(record.id), children: record.serialNumber })),
        },
        {
            title: "Статус",
            dataIndex: "status",
            key: "status",
            sorter: true,
            render: (status) => status,
            width: 120,
        },
        {
            title: "Дата изготовления",
            dataIndex: "manufactureDate",
            key: "manufactureDate",
            sorter: true,
            render: (date) => date ? new Date(date).toLocaleDateString("ru-RU") : "-",
        },
        {
            title: "Сессий зарядки",
            dataIndex: "totalChargingSessions",
            key: "totalChargingSessions",
            sorter: true,
            render: (sessions) => sessions || 0,
        },
        {
            title: "Энергии доставлено (кВт⋅ч)",
            dataIndex: "totalKwhDelivered",
            key: "totalKwhDelivered",
            sorter: true,
            render: (kwh) => (kwh ? `${kwh.toFixed(1)}` : "0"),
        },
        {
            title: "Текущий заряд (кВт⋅ч)",
            dataIndex: "currentChargeLevel",
            key: "currentChargeLevel",
            sorter: true,
            render: (level) => `${level.toFixed(1)}`,
        },
        {
            title: "Последнее обслуживание",
            dataIndex: "lastMaintenanceDate",
            key: "lastMaintenanceDate",
            sorter: true,
            render: (date) => date ? new Date(date).toLocaleDateString("ru-RU") : "-",
        },
        {
            title: "Следующее обслуживание",
            dataIndex: "nextMaintenanceDate",
            key: "nextMaintenanceDate",
            sorter: true,
            render: (date) => date ? new Date(date).toLocaleDateString("ru-RU") : "-",
        },
        {
            title: "Действия",
            key: "actions",
            width: 120,
            render: (_, record) => canDelete && (_jsx(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", children: _jsx(Button, { type: "text", icon: _jsx(DeleteOutlined, {}), danger: true, size: "small", onClick: () => handleDeleteStation(record.id) }) })),
        },
    ];
    const dataTableConfig = {
        header: {
            title: "Зарядные станции",
            actions: canEdit ? (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => handleViewStation(), children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u0430\u043D\u0446\u0438\u044E" })) : undefined,
            extraContent: (_jsx(Filters, { filtersStore: filtersStore, title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438 \u043F\u043E\u0438\u0441\u043A", showClearAll: true, showApplyButton: false })),
        },
        columns: columns,
        rowKey: "id",
        scroll: { x: 1500 },
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return _jsx(DataTable, { store: dataTable, config: dataTableConfig });
});
export default ChargingStationsPage;
